var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex items-center cursor-pointer",on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('span',{staticClass:"text-black opacity-60 transition-colors hover:text-red hover:opacity-100"},[_vm._v(_vm._s(_vm.label))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }